export default {
    data () {
        return {
            industryArray: [{
                "label": "农、林、牧、渔业",
                "value": "A",
                "children": [{
                    "label": "农业",
                    "value": "01"
                }, {
                    "label": "林业",
                    "value": "02"
                }, {
                    "label": "畜牧业",
                    "value": "03"
                }, {
                    "label": "渔业",
                    "value": "04"
                }, {
                    "label": "农、林、牧、渔专业及辅助性活动",
                    "value": "05"
                }]
            }, {
                "label": "采矿业",
                "value": "B",
                "children": [{
                    "label": "煤炭开采和洗选业",
                    "value": "06"
                }, {
                    "label": "石油和天然气开采业",
                    "value": "07"
                }, {
                    "label": "黑色金属矿采选业",
                    "value": "08"
                }, {
                    "label": "有色金属矿采选业",
                    "value": "09"
                }, {
                    "label": "非金属矿采选业",
                    "value": "10"
                }, {
                    "label": "开采专业及辅助性活动",
                    "value": "11"
                }, {
                    "label": "其他采矿业",
                    "value": "12"
                }]
            }, {
                "label": "制造业",
                "value": "C",
                "children": [{
                    "label": "农副食品加工业",
                    "value": "13"
                }, {
                    "label": "食品制造业",
                    "value": "14"
                }, {
                    "label": "酒、饮料和精制茶制造业",
                    "value": "15"
                }, {
                    "label": "烟草制品业",
                    "value": "16"
                }, {
                    "label": "纺织业",
                    "value": "17"
                }, {
                    "label": "纺织服装、服饰业",
                    "value": "18"
                }, {
                    "label": "皮革、毛皮、羽毛及其制品和制鞋业",
                    "value": "19"
                }, {
                    "label": "木材加工和木、竹、藤、棕、草制品业",
                    "value": "20"
                }, {
                    "label": "家具制造业",
                    "value": "21"
                }, {
                    "label": "造纸和纸制品业",
                    "value": "22"
                }, {
                    "label": "印刷和记录媒介复制业",
                    "value": "23"
                }, {
                    "label": "文教、工美、体育和娱乐用品制造业",
                    "value": "24"
                }, {
                    "label": "化学原料和化学制品制造业",
                    "value": "26"
                }, {
                    "label": "医药制造业",
                    "value": "27"
                }, {
                    "label": "化学纤维制造业",
                    "value": "28"
                }, {
                    "label": "橡胶和塑料制品业",
                    "value": "29"
                }, {
                    "label": "非金属矿物制品业",
                    "value": "30"
                }, {
                    "label": "黑色金属冶炼和压延加工业",
                    "value": "31"
                }, {
                    "label": "有色金属冶炼和压延加工业",
                    "value": "32"
                }, {
                    "label": "金属制品业",
                    "value": "33"
                }, {
                    "label": "通用设备制造业",
                    "value": "34"
                }, {
                    "label": "专用设备制造业",
                    "value": "35"
                }, {
                    "label": "汽车制造业",
                    "value": "36"
                }, {
                    "label": "铁路、船舶、航空航天和其他运输设备制造业",
                    "value": "37"
                }, {
                    "label": "电气机械和器材制造业",
                    "value": "38"
                }, {
                    "label": "计算机、通信和其他电子设备制造业",
                    "value": "39"
                }, {
                    "label": "仪器仪表制造业",
                    "value": "40"
                }, {
                    "label": "其他制造业",
                    "value": "41"
                }, {
                    "label": "废弃资源综合利用业",
                    "value": "42"
                }, {
                    "label": "金属制品、机械和设备修理业",
                    "value": "43"
                }]
            }, {
                "label": "电力、热力、燃气及水生产和供应业",
                "value": "D",
                "children": [{
                    "label": "电力、热力生产和供应业",
                    "value": "44"
                }, {
                    "label": "燃气生产和供应业",
                    "value": "45"
                }, {
                    "label": "水的生产和供应业",
                    "value": "46"
                }]
            }, {
                "label": "建筑业",
                "value": "E",
                "children": [{
                    "label": "房屋建筑业",
                    "value": "47"
                }, {
                    "label": "土木工程建筑业",
                    "value": "48"
                }, {
                    "label": "建筑安装业",
                    "value": "49"
                }, {
                    "label": "建筑装饰、装修和其他建筑业",
                    "value": "50"
                }]
            }, {
                "label": "批发和零售业",
                "value": "F",
                "children": [{
                    "label": "批发业",
                    "value": "51"
                }, {
                    "label": "零售业",
                    "value": "52"
                }]
            }, {
                "label": "交通运输、仓储和邮政业",
                "value": "G",
                "children": [{
                    "label": "铁路运输业",
                    "value": "53"
                }, {
                    "label": "道路运输业",
                    "value": "54"
                }, {
                    "label": "水上运输业",
                    "value": "55"
                }, {
                    "label": "航空运输业",
                    "value": "56"
                }, {
                    "label": "管道运输业",
                    "value": "57"
                }, {
                    "label": "多式联运和运输代理业",
                    "value": "58"
                }, {
                    "label": "装卸搬运和仓储业",
                    "value": "59"
                }, {
                    "label": "邮政业",
                    "value": "60"
                }]
            }, {
                "label": "住宿和餐饮业",
                "value": "H",
                "children": [{
                    "label": "住宿业",
                    "value": "61"
                }, {
                    "label": "餐饮业",
                    "value": "62"
                }]
            }, {
                "label": "信息传输、软件和信息技术服务业",
                "value": "I",
                "children": [{
                    "label": "电信、广播电视和卫星传输服务",
                    "value": "63"
                }, {
                    "label": "互联网和相关服务",
                    "value": "64"
                }, {
                    "label": "软件和信息技术服务业",
                    "value": "65"
                }]
            }, {
                "label": "金融业",
                "value": "J",
                "children": [{
                    "label": "货币金融服务",
                    "value": "66"
                }, {
                    "label": "资本市场服务",
                    "value": "67"
                }, {
                    "label": "保险业",
                    "value": "68"
                }, {
                    "label": "其他金融业",
                    "value": "69"
                }]
            }, {
                "label": "房地产业",
                "value": "K",
                "children": [{
                    "label": "房地产业",
                    "value": "70"
                }]
            }, {
                "label": "租赁和商务服务业",
                "value": "L",
                "children": [{
                    "label": "租赁业",
                    "value": "71"
                }, {
                    "label": "商务服务业",
                    "value": "72"
                }]
            }, {
                "label": "科学研究和技术服务业",
                "value": "M",
                "children": [{
                    "label": "研究和试验发展",
                    "value": "73"
                }, {
                    "label": "专业技术服务业",
                    "value": "74"
                }, {
                    "label": "科技推广和应用服务业",
                    "value": "75"
                }]
            }, {
                "label": "水利、环境和公共设施管理业",
                "value": "N",
                "children": [{
                    "label": "水利管理业",
                    "value": "76"
                }, {
                    "label": "生态保护和环境治理业",
                    "value": "77"
                }, {
                    "label": "公共设施管理业",
                    "value": "78"
                }, {
                    "label": "土地管理业",
                    "value": "79"
                }]
            }, {
                "label": "居民服务、修理和其他服务业",
                "value": "O",
                "children": [{
                    "label": "居民服务业",
                    "value": "80"
                }, {
                    "label": "机动车、电子产品和日用产品修理业",
                    "value": "81"
                }, {
                    "label": "其他服务业",
                    "value": "82"
                }]
            }, {
                "label": "教育",
                "value": "P",
                "children": [{
                    "label": "教育",
                    "value": "83"
                }]
            }, {
                "label": "卫生和社会工作",
                "value": "Q",
                "children": [{
                    "label": "卫生",
                    "value": "84"
                }, {
                    "label": "社会工作",
                    "value": "85"
                }]
            }, {
                "label": "文化、体育和娱乐业",
                "value": "R",
                "children": [{
                    "label": "新闻和出版业",
                    "value": "86"
                }, {
                    "label": "广播、电视、电影和录音制作业",
                    "value": "87"
                }, {
                    "label": "文化艺术业",
                    "value": "88"
                }, {
                    "label": "体育",
                    "value": "89"
                }, {
                    "label": "娱乐业",
                    "value": "90"
                }]
            }, {
                "label": "公共管理、社会保障和社会组织",
                "value": "S",
                "children": [{
                    "label": "中国共产党机关",
                    "value": "91"
                }, {
                    "label": "国家机构",
                    "value": "92"
                }, {
                    "label": "人民政协、民主党派",
                    "value": "93"
                }, {
                    "label": "社会保障",
                    "value": "94"
                }, {
                    "label": "群众团体、社会团体和其他成员组织",
                    "value": "95"
                }, {
                    "label": "基层群众自治组织",
                    "value": "96"
                }]
            }, {
                "label": "国际组织",
                "value": "T",
                "children": [{
                    "label": "国际组织",
                    "value": "97"
                }]
            }],
            industryMap: {
                "10": "非金属矿采选业",
                "11": "开采专业及辅助性活动",
                "12": "其他采矿业",
                "13": "农副食品加工业",
                "14": "食品制造业",
                "15": "酒、饮料和精制茶制造业",
                "16": "烟草制品业",
                "17": "纺织业",
                "18": "纺织服装、服饰业",
                "19": "皮革、毛皮、羽毛及其制品和制鞋业",
                "20": "木材加工和木、竹、藤、棕、草制品业",
                "21": "家具制造业",
                "22": "造纸和纸制品业",
                "23": "印刷和记录媒介复制业",
                "24": "文教、工美、体育和娱乐用品制造业",
                "26": "化学原料和化学制品制造业",
                "27": "医药制造业",
                "28": "化学纤维制造业",
                "29": "橡胶和塑料制品业",
                "30": "非金属矿物制品业",
                "31": "黑色金属冶炼和压延加工业",
                "32": "有色金属冶炼和压延加工业",
                "33": "金属制品业",
                "34": "通用设备制造业",
                "35": "专用设备制造业",
                "36": "汽车制造业",
                "37": "铁路、船舶、航空航天和其他运输设备制造业",
                "38": "电气机械和器材制造业",
                "39": "计算机、通信和其他电子设备制造业",
                "40": "仪器仪表制造业",
                "41": "其他制造业",
                "42": "废弃资源综合利用业",
                "43": "金属制品、机械和设备修理业",
                "44": "电力、热力生产和供应业",
                "45": "燃气生产和供应业",
                "46": "水的生产和供应业",
                "47": "房屋建筑业",
                "48": "土木工程建筑业",
                "49": "建筑安装业",
                "50": "建筑装饰、装修和其他建筑业",
                "51": "批发业",
                "52": "零售业",
                "53": "铁路运输业",
                "54": "道路运输业",
                "55": "水上运输业",
                "56": "航空运输业",
                "57": "管道运输业",
                "58": "多式联运和运输代理业",
                "59": "装卸搬运和仓储业",
                "60": "邮政业",
                "61": "住宿业",
                "62": "餐饮业",
                "63": "电信、广播电视和卫星传输服务",
                "64": "互联网和相关服务",
                "65": "软件和信息技术服务业",
                "66": "货币金融服务",
                "67": "资本市场服务",
                "68": "保险业",
                "69": "其他金融业",
                "70": "房地产业",
                "71": "租赁业",
                "72": "商务服务业",
                "73": "研究和试验发展",
                "74": "专业技术服务业",
                "75": "科技推广和应用服务业",
                "76": "水利管理业",
                "77": "生态保护和环境治理业",
                "78": "公共设施管理业",
                "79": "土地管理业",
                "80": "居民服务业",
                "81": "机动车、电子产品和日用产品修理业",
                "82": "其他服务业",
                "83": "教育",
                "84": "卫生",
                "85": "社会工作",
                "86": "新闻和出版业",
                "87": "广播、电视、电影和录音制作业",
                "88": "文化艺术业",
                "89": "体育",
                "90": "娱乐业",
                "91": "中国共产党机关",
                "92": "国家机构",
                "93": "人民政协、民主党派",
                "94": "社会保障",
                "95": "群众团体、社会团体和其他成员组织",
                "96": "基层群众自治组织",
                "97": "国际组织",
                "01": "农业",
                "A": "农、林、牧、渔业",
                "02": "林业",
                "B": "采矿业",
                "03": "畜牧业",
                "C": "制造业",
                "04": "渔业",
                "D": "电力、热力、燃气及水生产和供应业",
                "05": "农、林、牧、渔专业及辅助性活动",
                "E": "建筑业",
                "06": "煤炭开采和洗选业",
                "F": "批发和零售业",
                "07": "石油和天然气开采业",
                "G": "交通运输、仓储和邮政业",
                "08": "黑色金属矿采选业",
                "H": "住宿和餐饮业",
                "09": "有色金属矿采选业",
                "I": "信息传输、软件和信息技术服务业",
                "J": "金融业",
                "K": "房地产业",
                "L": "租赁和商务服务业",
                "M": "科学研究和技术服务业",
                "N": "水利、环境和公共设施管理业",
                "O": "居民服务、修理和其他服务业",
                "P": "教育",
                "Q": "卫生和社会工作",
                "R": "文化、体育和娱乐业",
                "S": "公共管理、社会保障和社会组织",
                "T": "国际组织"
            }
        }
    },
    methods: {
        // 行业字典变更时使用此方法重新生成数据
        getIndustryArrayAndMapByDictionary (dictionary) {
            const tempMap = {}
            const array = []
            const map = {}
            dictionary.forEach(item => {
                if (item.parentKey) { // 子节点
                    if (tempMap[item.parentKey]) tempMap[item.parentKey].push({ label: item.value, value: item.key })
                    else tempMap[item.parentKey] = [{ label: item.value, value: item.key }]
                } else { // 父节点
                    if (!tempMap[item.key]) tempMap[item.key] = []
                    array.push({ label: item.value, value: item.key ,children: tempMap[item.key] })
                }
                map[item.key] = item.value
            })
            array.forEach(item => item.children.length === 0 && delete item.children)
            return { array, map }
        }
    }
}
